import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  loading: {
    position: "absolute",
    top: "50%",
    left: 0,
    right: 0,
    marginLeft: "auto",
    marginRight: "auto",
    width: "40px",
    height: "40px",
  },
}));
